// The MCP servers whose usage is reported under the AI Usage → MCP view. Each
// value is the counts-service product id (`/v2/cids/:cid/products/:product/usage`),
// and all of them share the same usage row shape (key, target, sub_label, user,
// count) — so one view renders any of them. Add a server here to surface it.
export const MCP_SERVERS = [
    { label: 'MCP', value: 'mcp' },  // data plane mcp server usage
    { label: 'MCP Control', value: 'mcp_control' },  // control plane mcp server usage
];

export const DEFAULT_MCP_SERVER = MCP_SERVERS[0].value;

/** Falls back to the default for a missing or unrecognized `?server=` param. */
export function resolveMcpServer(server) {
    return MCP_SERVERS.some(s => s.value === server) ? server : DEFAULT_MCP_SERVER;
}
